<template>
	<div class="coursetest_wrap" :style="'height:'+height" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="course_cont">
			<div class="top_head">
				<span>考试列表</span>
				<el-button type="primary" @click="addTest">添加考试</el-button>
			</div>
			<div class="table" v-if="tableData.length">
				<div class="header_title">
					<p>考试名称</p>
					<p>总分/题数</p>
					<p>考试时长</p>
					<p>考试时间</p>
					<p>教学班</p>
					<p>操作</p>
				</div>
				<div class="teach_class">
					<li class="tab_item" v-for="(item,index) in tableData" :key="index">
						<p>{{item.paperName}}</p>
						<p>{{item.totalScore.split(".")[0]}}分/{{item.totalQuestion}}题</p>
						<p>{{item.examTime}}分钟</p>
						<p>{{item.examStartTime.slice(0,10)}}/{{item.examEndTime.slice(0,10)}}</p>
						<p :title="handleTestClass(item.examPaperClassRespList)">{{handleTestClass(item.examPaperClassRespList)}}</p>
						<p class="operation">
	      			<span class="into" @click="preview(item)">预览</span>
	            <span class="edit" @click="editorExam(item)">编辑</span>
	            <span class="del" @click="delExam(item)">删除</span>
	      		</p>
					</li>
				</div>
			</div>
			<div class="noList" v-else>
				<img src="../../../../../static/images/common/noorder_pic.png"/>
				<p>暂无考试</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Pagination from "../../../paginator/paginator.vue";
	import * as api from "../../../../api/individualApi";
	export default {
		components: {
	    Pagination
	  },
		data(){
			return {
				height:window.innerHeight - 236+"px",
				tableData:[],
				loading: true
			}
		},
		created(){
			this.getTestList();
		},
		methods: {
			// 获取考试列表
			getTestList(){
				api.getTestList(this.$route.query.courseId).then(res=>{
					if(res.code == 0){
						this.loading = false;
						this.tableData = res.data;
					}
				})
			},
			// 处理考试班级回显
			handleTestClass(arr){
				let newArr = [];
				let str = '';
				arr.forEach(val=>{
					newArr.push(val.className)
				});
				str = newArr.join(',');
				return str 
			},
			// 添加考试进入
			addTest(){
				this.$router.push({
					path:'/AddExam',
					query:{
						courseId: this.$route.query.courseId,
            subjectId: this.$route.query.subjectId,
            index: 'fourth'
					}
				})
			},
			// 编辑考试进入
			editorExam(item){
				this.$router.push({
					path:'/AddExam',
					query:{
						courseId: this.$route.query.courseId,
						subjectId: this.$route.query.subjectId,
            paperId: item.id,
            index: 'fourth'
					}
				});
			},
			// 删除考试
			delExam(item){
				this.$tipsDialog(
					"提示",
      		"确定删除该考试吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
				).then(() => {
					this.loading = true;
					api.delExam(this.$route.query.courseId,item.id,item.examId).then(res=>{
			  		if(res.code == 0){
			  			this.getTestList();
			  			this.$messageSuccess('删除成功');
			  		}
			  	}).catch(error => {});
       	}).catch(() => {});
			},
			preview(item){
				console.log(item);
				const { href } = this.$router.resolve({
	        path: '/switch/test/preview',
	        query: {
	          paperId: item.id,
	          id: this.$route.query.courseId
	        }
	      });
	      window.open(href, '_blank');
			}
		}
	}
</script>

<style scoped lang="scss">
	.coursetest_wrap {
		overflow-y: auto;
		.course_cont {
			.top_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				span {
					font-size: 14px;
					color: #5D646E;
				}
				.el-button {
					padding: 9px 27px;
				}
			}
			.table {
				margin-top: 10px;
				.header_title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					p {
						font-size:12px;
	          color:rgba(93,100,110,1);
	          text-align: left;
	          &:nth-child(1){ flex: 1; padding: 0 16px; box-sizing: border-box; }
	          &:nth-child(2){ width: 10%; }
	          &:nth-child(3){ width: 10%; }
	          &:nth-child(4){ width: 20%; }
	          &:nth-child(5){ flex: 1; padding: 0 16px; box-sizing: border-box;}
	          &:nth-child(6){ width: 160px; text-align: center;}
					}
					img {
						display: inline-block;
						width: 12px;
						height: 12px;
						margin-left: 2px;
					} 
				}
				.teach_class {
					.tab_item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height:40px;
						background:rgba(246,248,251,1);
						border-radius:4px;
						margin: 8px 0;
						&:hover {
							background: #E9EEF5;
						}
						p {
							font-size:12px;
		          color: #0D141E;
		          text-align: left;
		          &:nth-child(1){ flex: 1; padding: 0 16px; box-sizing: border-box; }
		          &:nth-child(2){ width: 10%; }
		          &:nth-child(3){ width: 10%; }
		          &:nth-child(4){ width: 20%; }
		          &:nth-child(5){ flex: 1; padding: 12px 16px; box-sizing: border-box; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
		          &:nth-child(6){ width: 160px; text-align: center;}
						}
						.operation {
							display: flex;
							justify-content: space-around;
							cursor: pointer;
							span {
								color: #545A64;
								font-size: 12px;
								&:hover {
									color: #5397F7;
								}
							}
						}
					}
				}
			}
			.noList {
				display: flex;
				flex-direction: column;
				align-items: center;
				img {
					display: inline-block;
					margin-top: 10%;
					width: 250px;
					height: 170px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/components/courseTest.vue